import React, { useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "rgba(255,255,255, 0.5) !important",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    "& .MuiCircularProgress-root": {
      position: "absolute"
    }
  },
  blurWrapper: {
    top: 0,
    backgroundColor: "rgba(255,255,255, .9) !imoprtant",
    display: ({ drawerOpen }) => !drawerOpen && "none"
  },
  blur: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backdropFilter: "blur(10px)"
  },
  status: {
    position: "relative",
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    textTransform: "capitalize",
    height: theme.spacing(2.5),
    lineHeight: theme.spacing(2.5) + "px",
    marginTop: theme.spacing(-1.5)
  },
  btn: {
    textTransform: "none",
    padding: theme.spacing(1.125, 3),
    fontSize: "0.9375rem",
    lineHeight: "1.125rem",
    top: "calc(50% + 48px)",
    position: "absolute",
    minWidth: 0
  },
  drawerExpanded: {
    left: "280px"
  }
}));

function LoadingCircle({
  drawerExpanded,
  hideCircle,
  blur,
  cancel,
  handleCancelUpload,
  drawerOpen,
  ...props
}) {
  const classes = useStyles({ drawerOpen });

  return (
    <div
      className={clsx(classes.root, {
        [classes.drawerExpanded]: drawerExpanded,
        [classes.blurWrapper]: blur
      })}
      {...props}
    >
      {blur && <div className={classes.blur}></div>}
      {!hideCircle && <CircularProgress />}
      {cancel && (
        <Button
          color="primary"
          component="button"
          onClick={() => handleCancelUpload()}
          className={classes.btn}
        >
          Cancel
        </Button>
      )}
    </div>
  );
}

export const LoadingCircleWithLabel = ({ drawerExpanded, blur, ...props }) => {
  const classes = useStyles();

  let status;

  switch (props.status) {
    case "preparing":
    case "reoptimized":
      status = "Preparing";
      break;
    case "in_progress":
      status = "In Progress";
      break;
    default:
      status = props.status;
  }

  const [tick, setTick] = useState(0);

  useEffect(() => {
    let interval = setInterval(() => {
      setTick(tick >= 3 ? 0 : tick + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [tick]);

  return (
    <div
      className={clsx(classes.root, {
        [classes.drawerExpanded]: drawerExpanded,
        [classes.blurWrapper]: blur
      })}
      {...props}
    >
      {blur && <div className={classes.blur}></div>}
      <Typography variant="body2" component="div" className={classes.status}>
        {status} {!!props.status && ".".repeat(tick)}
      </Typography>
      {status === "Preparing" && !props.value ? (
        <CircularProgress />
      ) : (
        <Box position="relative" display="inline-flex">
          <CircularProgress
            className={classes.determinate}
            variant="static"
            value={props.value || 0}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="caption"
              component="div"
              color="textSecondary"
            >{`${Math.round(props.value || 0)}%`}</Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default LoadingCircle;
